import { Authentication } from '../models';
import ApiResource from './ApiResource';

class AuthResource extends ApiResource<Authentication> {
  public endpoint = '/login';
}

export const authResource = new AuthResource();
